export const DASHBOARD_START_LOADING_PROPERTIES = 'DASHBOARD_START_LOADING_PROPERTIES';
export const DASHBOARD_STOP_LOADING_PROPERTIES = 'DASHBOARD_STOP_LOADING_PROPERTIES';
export const DASHBOARD_START_LOADING_MORE_PROPERTIES = 'DASHBOARD_START_LOADING_MORE_PROPERTIES';
export const DASHBOARD_STOP_LOADING_MORE_PROPERTIES = 'DASHBOARD_STOP_LOADING_MORE_PROPERTIES';
export const DASHBOARD_SET_PROPERTIES_ERROR = 'DASHBOARD_SET_PROPERTIES_ERROR';

export const DASHBOARD_SET_VERSION = 'DASHBOARD_SET_VERSION';
export const DASHBOARD_SET_SWITCH_VISIBILITY = 'DASHBOARD_SET_SWITCH_VISIBILITY';

export const DASHBOARD_CHANGE_DATE_ACTIVITY = 'DASHBOARD_CHANGE_DATE_ACTIVITY';
export const DASHBOARD_CHANGE_ORDER = 'DASHBOARD_CHANGE_ORDER';

export const DASHBOARD_RESET_DASHBOARD_OPTIONS = 'DASHBOARD_RESET_DASHBOARD_OPTIONS';

// Map dashboard
export const MAP_DASHBOARD_START_LOADING_PEOPLE = 'MAP_DASHBOARD_START_LOADING_PEOPLE';
export const MAP_DASHBOARD_STOP_LOADING_PEOPLE = 'MAP_DASHBOARD_STOP_LOADING_PEOPLE';

export const MAP_DASHBOARD_START_LOADING_PROPERTIES = 'MAP_DASHBOARD_START_LOADING_PROPERTIES';
export const MAP_DASHBOARD_STOP_LOADING_PROPERTIES = 'MAP_DASHBOARD_STOP_LOADING_PROPERTIES';
